import { AcceptChanges } from 'almanac-ui/icons/24'
import cx from 'classnames'
import { Button } from 'components/Button'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import Styles from './TrackChangesButtons.module.scss'

const AcceptAllButton = observer(() => {
  const docStore = useDocStore()
  const { acceptAll, changesCount, canAcceptChanges } = docStore.trackedChangesStore
  const isDisabled = !canAcceptChanges || !changesCount

  return (
    <Button
      size="md"
      isDisabled={isDisabled}
      onPress={acceptAll}
      variant="tertiary"
      frontIcon={AcceptChanges}
      iconClassName={cx(Styles.icon, Styles.doubleClassOverride)}
      className={cx(Styles.button, Styles.doubleClassOverride)}
    >
      Accept all changes
    </Button>
  )
})

export { AcceptAllButton }
